import React, { useEffect, useState, useMemo, useRef  } from 'react'
import apiService from '../../service/apiService';
import Chart from 'react-apexcharts';
import "../../scenes/dashboard/index.css";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import OdishaDist from "../../Orissa.json";
import { geoCentroid } from "d3-geo";
import { Link } from "react-router-dom";
import logo from '../../assets/images/icardalogo.png';
import { IMG_URL } from "../../service/ImageUrl";
import { format, parseISO } from "date-fns";

const DistrictMap = React.memo(({ districtDataMap }) => {
  const [hoveredDistrict, setHoveredDistrict] = useState(null);

  return (
    <div style={{ position: "relative" }}>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{
          scale: 6000,
          center: [84.5, 20.2],
        }}
        style={{ width: "100%", height: "100%" }}
      >
        <Geographies geography={OdishaDist}>
          {({ geographies, projection }) =>
            geographies.map((geo) => {
              const districtName = geo.properties.Dist_Name;
              const isSelected = districtDataMap.has(districtName);
              const centroid = geoCentroid(geo);
              const projectedCentroid = projection(centroid);

              return (
                <g key={geo.rsmKey}>
                  <Geography
                    geography={geo}
                    onMouseOver={() => {
                      if (isSelected) {
                        const districtInfo = districtDataMap.get(districtName);
                        setHoveredDistrict(districtInfo);
                      }
                    }}
                    onMouseOut={() => setHoveredDistrict(null)}
                    style={{
                      default: {
                        fill: isSelected ? "#FF5722" : "#D6D6DA",
                        outline: "none",
                        stroke: "#000000",
                      },
                      hover: {
                        fill: "#FFB74D",
                        outline: "none",
                        stroke: "#000000",
                      },
                      pressed: {
                        fill: "#FF5722",
                        outline: "none",
                        stroke: "#000000",
                      },
                    }}
                  />
                  {projectedCentroid && (
                    <text
                      x={projectedCentroid[0]}
                      y={projectedCentroid[1]}
                      textAnchor="middle"
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontSize: "10px",
                        fill: "#000",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      {districtName}
                    </text>
                  )}
                </g>
              );
            })
          }
        </Geographies>
      </ComposableMap>

      {hoveredDistrict && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            padding: "10px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
            zIndex: 10,
          }}
        >
          <h5 className='mt-0 text-success fw-bold'>{hoveredDistrict.districtName}</h5>
          <p className='m-0'>Total Planned Area: <b>{hoveredDistrict.totalPlannedArea}</b> ha</p>
          <p className='m-0'>Total Cultivated Area: <b>{hoveredDistrict.totalCultivatedArea}</b> ha</p>
          <p className='m-0'>Total Farmers: <b>{hoveredDistrict.totalFarmer}</b></p>
          <p className='m-0'>Total Production Quantity: <b>{hoveredDistrict.totalProductionQuantity}</b> Qtl</p>
          <p className='m-0'>Total Additional Income: <b>₹ {hoveredDistrict.totalAdditionalIncome}</b></p>
        </div>
      )}
    </div>
  );
});
const GovtDashboard = () => {
    const [year, setYear] = useState(0);
    const [years, setYears] = useState([]);
    const [dists, setAllDists] = useState([]);
    const [dist, setDist] = useState(0);
    const [block, setBlock] = useState(0);
    const [blocks, setBlocks] = useState([]);
    const [seasons, setSeasons] = useState([]);
    const [season, setSeason] = useState(0);
    const [allcarddata, setAllCardData] = useState([]);
    const [allmapdata, setAllMapData] = useState([]);
    const [allareagraphdata, setAllAreaGraphData] = useState([]);
    const [allcolumndata, setAllColumnData] = useState([]);
    const [showDistDropdown, setShowDistDropdown] = useState(true);
    const [showBlockDropdown, setShowBlockDropdown] = useState(true);
    const [cropcuttingdata, setCropcuttingData] = useState([]);
    const [verifiedImg, setVerifiedImg] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [lightbox, setLightbox] = useState({ open: false, image: null, location:"", date:"", index: 0 });
  
    useEffect(() => {
      // console.log("it is calling more and more");
      const loginData = JSON.parse(localStorage.getItem("loginData")) || {};
      const districtId = loginData.districtId || 0;
      const blockId = loginData.blockId || 0;
      setDist(districtId);
      setBlock(blockId);
  
      if (districtId && blockId) {
        setShowDistDropdown(false);
        setShowBlockDropdown(false);
      } else if (districtId) {
        setShowDistDropdown(false);
        setShowBlockDropdown(true);
      } else if (blockId) {
        setShowDistDropdown(false);
        setShowBlockDropdown(false);
      } else {
        setShowDistDropdown(true);
        setShowBlockDropdown(true);
      }
    }, []);
    
    const fetchData = async () => {
      try {
        const response = await apiService.post("/dashboard/get-web-dashboard-data", {
          yearId: year,
          blockId: block,
          districtId: dist,
          seasonId:season
        });
  
        const data = response.data.body; 
        console.log("response is : ", data);
        setAllCardData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    const fetchAreaChartData = async () => {
      try {
        const response = await apiService.post("/dashboard/get-web-dashboard-production-data", {
          yearId: year,
          blockId: block,
          districtId: dist,
          seasonId:season
        });
  
        const data = response.data.body || []; 
        console.log("response is : ", data);
        setAllAreaGraphData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setAllAreaGraphData([]);
      }
    };
  
    const fetchMapData = async () => {
      try {
        const response = await apiService.post("/dashboard/get-district-wise-dashboard-aggregated-data", {
          yearId: year,
          blockId: block,
          districtId: dist,
          seasonId:season
        });
  
        const data = response.data.body; 
        console.log("response is of mapdata is : ", data);
        if (data && Array.isArray(data)) {
          setAllMapData(data);
        } else {
          setAllMapData([]);  
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    const fetchColumnData = async () => {
      try {
        const response = await apiService.post("/dashboard/eventcounts", {
          yearId: year,
          blockId: block,
          districtId: dist,
          seasonId:season
        });
  
        const data = response.data || []; 
        console.log("response is : ", data);
        setAllColumnData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setAllAreaGraphData([]);
      }
    };
  
    const fetchCropCuttingData = async () => {
      try {
        const response = await apiService.post("/dashboard/crop-cutting-graph", {
          yearId: year,
          blockId: block,
          districtId: dist,
          seasonId:season
        });
  
        const data = response.data.body || []; 
        // console.log("response is : ", data);
        setCropcuttingData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCropcuttingData([]);
      }
    };
    const fetchImageVerificationData = async () => {
        try {
          const response = await apiService.get(`/image-verification/get-govt-dashboard-data?seasonId=${season}&yearId=${year}`);
          const data = response.data.body || []; 
          // console.log("response is : ", data);
        setVerifiedImg(data);
        if (data.length > 0) {
            setSelectedCategory(data[0]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setVerifiedImg([]);
        }
      };
  
    useEffect(() => {
      if (year) {
        const delayFetch = setTimeout(() => {
          fetchData();
          fetchAreaChartData();
          fetchColumnData();
          fetchMapData();
          fetchCropCuttingData();
          fetchImageVerificationData();
        }, 300); 
    
        return () => clearTimeout(delayFetch);
      }
    }, [year, dist, block, season]);      
  
  
    const fetchYears = async () => {
      try {
        const response = await apiService.get("/years/get-all");
        const fetchedYears = response.data;
  
        setYears(fetchedYears);
  
        const currentYear = new Date().getFullYear();
        const matchingYear = fetchedYears.find((yr) => yr.yearValue === currentYear);
  
        setYear(matchingYear ? matchingYear.yearId : fetchedYears[0]?.yearId);
      } catch (error) {
        console.error("Error fetching years:", error);
      }
    };
  
    const fetchAllDist = async () => {
      try {
        const response = await apiService.get('/districts/get-all');
        setAllDists(response.data);
      } catch (error) {
        console.error('Error fetching seeds:', error);
      }
    };
  
    const fetchBlocks = async () => {
      try {
        const response = await apiService.get(`/master/get-block-by-district/${dist}`);
        setBlocks(response.data.body.blocks);
      } catch (error) {
        console.error("Error fetching blocks:", error);
      }
    }
  
    const fetchSeasons = async () => {
      try {
        const response = await apiService.get("/seasons/get-all");
        setSeasons(response.data);
      } catch (error) {
        console.error("Error fetching seasons:", error);
      }
    };
  
    useEffect(() => {
      fetchYears();
      fetchAllDist();
      fetchSeasons();
    }, []);
  
    useEffect(() => {
      if (dist > 0) {
        fetchBlocks();
      }
    }, [dist]);
  
    const seedname = allareagraphdata.map(item => item.seedName); // Seed names for x-axis
    const cultivatedArea = allareagraphdata.map(item => item.cultivatedArea); // Series 1
    const yieldData = allareagraphdata.map(item => item.yield);
    const eventname = allcolumndata.map(item => item.name);
    const eventnum = allcolumndata.map(item => item.eventNumber);
    const seednamecc = cropcuttingdata.map(item => item.seedName);
    const yieldDatacc = cropcuttingdata.map(item => item.yield5x5); 
    const totalCropcutting = cropcuttingdata.map(item => item.yieldPerHectare); 
    const maleFarmer = allcarddata?.totalMaleFarmerCount || 0;
    const femaleFarmer = allcarddata?.totalFemaleFarmerCount || 0;
    
    const series = [{
      name: 'Cultivated Area',
      type: 'column',
      data: cultivatedArea
    }, {
      name: 'Yield',
      type: 'line',
      data: yieldData
    }];
  
    const AreaChart = React.memo(() => {
      const options = {
        chart: {
          height: 450,
          type: "line",
          zoom: { enabled: false },
          pan: { enabled: false },
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
          },
        },
        stroke: {
          width: [0, 4],
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: [0, 4],
          hover: {
            size: 5,
          },
        },
        tooltip: {
          enabled: true,
        },
        labels: seedname,
      };
    
      return (
        <Chart
          options={options}
          series={series}
          height={options.chart.height}
          className="bg-white"
        />
      );
    });
    
    const CropCutingColumnChart = React.memo(() => {
      const options = {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "45%",
            barHeight: "100%",
            grouped: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: seednamecc,
        },
        fill: {
          opacity: 1,
        },
      };
    
      const series = [
        {
          name: "Yield (5×5)",
          data: yieldDatacc,
        },
        {
          name: "Total Crop cutting",
          data: totalCropcutting,
        },
      ];
    
      return (
        <Chart
          options={options}
          series={series}
          type="bar"
          height={options.chart.height}
          className="bg-white"
        />
      );
    });
    
    const ColumnChart = React.memo(() => {
      const options = {
        series: [
          {
            name: "No Of Events",
            data: eventnum,
          },
        ],
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "25%",
            borderRadius: 0,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: eventname,
        },
        yaxis: {
          title: {
            text: "No Of Events",
          },
        },
        fill: {
          opacity: 1,
        },
      };
    
      return (
        <Chart
          options={options}
          series={options.series}
          type="bar"
          height={options.chart.height}
          className="bg-white"
        />
      );
    });
    
    const DonutChart = React.memo(() => {
      const series = [maleFarmer, femaleFarmer];
    
      const options = {
        chart: {
          width: 420,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        labels: ["Male", "Female"],
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return `${val} - ${opts.w.globals.series[opts.seriesIndex]}`;
          },
          fontWeight: "bold",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    
      return (
        <Chart
          options={options}
          series={series}
          type="donut"
          width={options.chart.width}
        />
      );
    });
    
    const districtDataMap = useMemo(() => {
      const map = new Map();
      if (allmapdata) {
        allmapdata.forEach((item) => {
          map.set(item.districtName, item);
        });
      }
      return map;
    }, [allmapdata]);
  
    const formatNumberIndian = (num) => {
      if (num >= 1e7) {
        return `${(num / 1e7).toFixed(1)} C`;
      } else if (num >= 1e5) {
        return `${(num / 1e5).toFixed(1)} L`;
      } else if (num >= 1e3) {
        return `${(num / 1e3).toFixed(1)} K`;
      }
      return num.toString();
    };
    const openLightbox = (image, location, date, index) => {
        setLightbox({ open: true, image, location, date, index });
    };
    const closeLightbox = () => {
        setLightbox({ open: false, image: null, location:"", date:"", index: 0 });
    };
    const changeImage = (direction) => {
        let newIndex = lightbox.index + direction;
        if (newIndex >= selectedCategory.images.length) newIndex = 0;
        if (newIndex < 0) newIndex = selectedCategory.images.length - 1;
        setLightbox({ ...lightbox, image: selectedCategory.images[newIndex].url, location: selectedCategory.images[newIndex].location, date:selectedCategory.images[newIndex].date, index: newIndex });
    };
    return (
        <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>
        <div className="row mt-3 mb-2">
            <div className='d-flex justify-content-between'>
            <div className='pl-3'>
              <img src={logo} alt="Logo" style={{ width: "50px", height: "50px" }} />
            </div>
          <div className="d-flex flex-wrap justify-content-end">
            {/* Year Dropdown */}
            <div className="col-md-auto col-sm-12">
              <select className="form-select form-select-md" style={{ width: "150px" }} value={year} onChange={(e) => setYear(Number(e.target.value))}>
              <option value={0} disabled>
                  Select a Year
                </option>
                {years.map((yr) => (
                  <option key={yr.yearId} value={yr.yearId}>
                    {yr.yearValue}
                  </option>
                ))}
              </select>
            </div>
  
            {/* District Dropdown */}
            {showDistDropdown && (
            <div className="col-md-auto col-sm-12">
              <select className="form-select form-select-md" style={{ width: "150px" }} value={dist} onChange={(e) => { setDist(Number(e.target.value));}}>
              <option value={0}>
                          Select All Dist
                        </option>
                        {dists.map((dst) => (
                          <option key={dst.districtId} value={dst.districtId}>
                            {dst.districtName}
                          </option>
                        ))}
              </select>
            </div>
            )}
            {/* Block Dropdown */}
            {showBlockDropdown && (
            <div className="col-md-auto col-sm-12">
              <select className="form-select form-select-md" style={{ width: "150px" }} value={block} onChange={(e) => {setBlock(Number(e.target.value));}}>
              <option value={0}>Select All Block</option>
                        {blocks.map((blk) => (
                          <option key={blk.blockId} value={blk.blockId}>{blk.blockName}</option>
                        ))}
              </select>
            </div>
            )}
            {/* Season Dropdown */}
            <div className="col-md-auto col-sm-12">
              <select className="form-select form-select-md" style={{ width: "150px" }} value={season} onChange={(e) => {setSeason(Number(e.target.value));}}>
              <option value={0}>Select All Season</option>
                        {seasons.map((ses) => (
                          <option key={ses.seasonId} value={ses.seasonId}>{ses.seasonName}</option>
                        ))}
              </select>
            </div>
          </div>
          </div>
        </div>
          <div className="row d-flex">
            <div className="col-lg-3 col-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="small-box bg-info flex-fill">
                <div className="inner">
                  <h3>{allcarddata.totalPlannedArea ?? 0} ha</h3>
                  <h5>Target</h5>
                </div>
                <div className="icon">
                  <i className="ion ion-bag" />
                </div>
                {/* <Link to={{ pathname: "/cropmanagement" }}
                  state={{ year, dist, block, season  }}
                  className="small-box-footer"
                >
                  More info <i className="fas fa-arrow-circle-right" />
                </Link> */}
              </div>
            </div>
            <div className="col-lg-3 col-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="small-box bg-success flex-fill">
                <div className="inner">
                  <h3>{formatNumberIndian(allcarddata.totalRevenue ?? 0)}</h3>
                  <h5>Revenue</h5>
                </div>
                <div className="icon">
                  <i className="ion ion-stats-bars" />
                </div>
                {/* <Link to={{ pathname: "/marketlinkage" }}
                  state={{ year, dist, block, season  }}
                  className="small-box-footer"
                >
                  More info <i className="fas fa-arrow-circle-right" />
                </Link> */}
              </div>
            </div>
            <div className="col-lg-3 col-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="small-box bg-warning flex-fill">
                <div className="inner">
                  <h3>{allcarddata.totalPGCount ?? 0}</h3>
                  <h5>No Of PGs</h5>
                </div>
                <div className="icon">
                  <i className="ion ion-person-add" />
                </div>
                {/* <Link to={{ pathname: "/producergroup" }}
                  state={{ year, dist, block, season  }}
                  className="small-box-footer"
                >
                  More info <i className="fas fa-arrow-circle-right" />
                </Link> */}
              </div>
            </div>
            <div className="col-lg-3 col-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="small-box bg-danger flex-fill">
                <div className="inner">
                  <h3>{allcarddata.totalNoOfEvents ?? 0}</h3>
                  <h5>Activities</h5>
                </div>
                <div className="icon">
                  <i className="ion ion-pie-graph" />
                </div>
                {/* <Link to={{ pathname: "/capacitybuilding" }}
                  state={{ year, dist, block, season  }}
                  className="small-box-footer"
                >
                  More info <i className="fas fa-arrow-circle-right" />
                </Link> */}
              </div>
            </div>
          </div>
          <div className="row d-flex">
            <div className="col-lg-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    <h3 className="card-title">Involve Framers</h3>
                    {/* <a href="javascript:void(0);">View Report</a> */}
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex">
                    <p className="d-flex flex-column">
                      <span className="text-bold text-lg">{allcarddata.totalMaleFarmerCount+allcarddata.totalFemaleFarmerCount}</span>
                      <span>Total Farmers</span>
                    </p>
                    {/* <p className="ml-auto d-flex flex-column text-right">
                      <span className="text-success">
                        <i className="fas fa-arrow-up" /> 33.1%
                      </span>
                      <span className="text-muted">New Registered Since last month</span>
                    </p> */}
                  </div>
                  {/* /.d-flex */}
                  <div className="position-relative mb-4 d-flex justify-content-center align-items-center">
                    <div> 
                      <DonutChart />
                    </div>
                  </div>
                  {/* <div className="d-flex flex-row justify-content-end">
                    <span className="mr-2">
                      <i className="fas fa-square text-primary" /> This year
                    </span>
                    <span>
                      <i className="fas fa-square text-gray" /> Last year
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="card flex-fill">
                <div className="card-header">
                  <h3 className="card-title">
                    {/* <i className="fas fa-map-marker-alt mr-1" /> */}
                    District Wise Production
                  </h3>
                </div>
                <div className="card-body" style={{ padding: "0px", width: "100%" }}>
                   <DistrictMap districtDataMap={districtDataMap} />
                </div>
  
                {/* <div className="card-footer bg-transparent">
                  <div className="row">
                    <div className="col-4 text-center">
                      <div className="text-white">Visitors</div>
                    </div>
                    <div className="col-4 text-center">
                      <div className="text-white">Online</div>
                    </div>
                    <div className="col-4 text-center">
                      <div className="text-white">Sales</div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Achievement vs Target</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8">
                      {/* <p className="text-center">
                        <strong>Sales: 1 Jan, 2014 - 30 Jul, 2014</strong>
                      </p> */}
                      <div className="chart">
                        <div >
                          <AreaChart />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <p className="text-center">
                        <strong>Goal Completion</strong>
                      </p>
                      <div className="progress-group">
                      Cultivated Vs Planned Area
                        <span className="float-right"><b>{allcarddata.totalCultivatedArea ?? 0}</b>/{allcarddata.totalPlannedArea ?? 0}</span>
                        <div className="progress progress-sm">
                          <div className="progress-bar bg-primary" style={{ 
                              width: `${
                                  allcarddata.totalPlannedArea && allcarddata.totalCultivatedArea 
                                      ? ((allcarddata.totalCultivatedArea ?? 0) / (allcarddata.totalPlannedArea ?? 1)) * 100 
                                      : 0
                              }%` 
                          }}  />
                        </div>
                      </div>
                      <div className="progress-group">
                        Sell Vs Production Quantity 
                        <span className="float-right"><b>{allcarddata.totalSellQuantity ?? 0}</b>/{allcarddata.totalProductionQuantity ?? 0}</span>
                        <div className="progress progress-sm">
                          <div className="progress-bar bg-danger" style={{ 
                              width: `${
                                  allcarddata.totalProductionQuantity && allcarddata.totalSellQuantity 
                                      ? ((allcarddata.totalSellQuantity ?? 0) / (allcarddata.totalProductionQuantity ?? 1)) * 100 
                                      : 0
                              }%` 
                          }}  />
                        </div>
                      </div>
                      {/* <div className="progress-group">
                        <span className="progress-text">Visit Premium Page</span>
                        <span className="float-right"><b>480</b>/800</span>
                        <div className="progress progress-sm">
                          <div className="progress-bar bg-success" style={{ width: '60%' }} />
                        </div>
                      </div>
                      <div className="progress-group">
                        Send Inquiries
                        <span className="float-right"><b>250</b>/500</span>
                        <div className="progress progress-sm">
                          <div className="progress-bar bg-warning" style={{ width: '50%' }} />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                    <div className="col-sm-3 col-6">
                      <div className="description-block border-right">
                        {/* <span className="description-percentage text-success"><i className="fas fa-caret-up" /> 0%</span> */}
                        <h5 className="description-header">{allcarddata.totalPlannedArea}</h5>
                        <span className="description-text">PLANNED AREA (In Ha)</span>
                      </div>
                    </div>
                    <div className="col-sm-3 col-6">
                      <div className="description-block border-right">
                        {/* <span className="description-percentage text-warning"><i className="fas fa-caret-left" /> 0%</span> */}
                        <h5 className="description-header">{allcarddata.totalCultivatedArea}</h5>
                        <span className="description-text">CULTIVATION AREA (In Ha)</span>
                      </div>
                    </div>
                    <div className="col-sm-3 col-6">
                      <div className="description-block border-right">
                        {/* <span className="description-percentage text-success"><i className="fas fa-caret-up" /> 0%</span> */}
                        <h5 className="description-header">{allcarddata.totalProductionQuantity ?? 0}</h5>
                        <span className="description-text">TOTAL YIELD (In Qtl)</span>
                      </div>
                    </div>
                    <div className="col-sm-3 col-6">
                      <div className="description-block">
                        {/* <span className="description-percentage text-danger"><i className="fas fa-caret-down" /> 0%</span> */}
                        <h5 className="description-header">₹ {formatNumberIndian(allcarddata.totalAdditionalIncome ?? 0)}</h5>
                        <span className="description-text">ADD INCOME</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex">
            <div className="col-lg-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    <h3 className="card-title">Event & Activities</h3>
                    {/* <a href="javascript:void(0);">View Report</a> */}
                  </div>
                </div>
                <div className="card-body">
                  {/* <div className="d-flex">
                    <p className="d-flex flex-column">
                      <span className="text-bold text-lg">$18,230.00</span>
                      <span>Sales Over Time</span>
                    </p>
                    <p className="ml-auto d-flex flex-column text-right">
                      <span className="text-success">
                        <i className="fas fa-arrow-up" /> 33.1%
                      </span>
                      <span className="text-muted">Since last month</span>
                    </p>
                  </div> */}
                  <div className="position-relative mb-4">
                    <div>
                      <ColumnChart />
                    </div>
                  </div>
                  {/* <div className="d-flex flex-row justify-content-end">
                    <span className="mr-2">
                      <i className="fas fa-square text-primary" /> This year
                    </span>
                    <span>
                      <i className="fas fa-square text-gray" /> Last year
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6" style={{ display: "flex", flexDirection: "column" }}>
              <div className="card flex-fill">
                <div className="card-header">
                  <h3 className="card-title">Crop Cutting Analysis</h3>
                </div>
                <div className="card-body">
                  <div className="position-relative mb-4">
                    <div>
                      <CropCutingColumnChart />
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Image Verification</h5>
                </div>
                <div className="card-body p-0">
                    <div className="row px-2">
                        <div className="col-md-2  d-flex flex-column align-items-center" style={{ borderRight: "2px solid #ddd" }}>
                            <ul style={{ listStyle: "none", padding: "0" }}>
                                {verifiedImg.map((category, index) => (
                                    <li
                                        key={index}
                                        onClick={() => setSelectedCategory(category)}
                                        style={{
                                            padding: "10px",
                                            fontSize: "16px",
                                            color: selectedCategory?.name === category.name ? "#007bff" : "#333",
                                            fontWeight: selectedCategory?.name === category.name ? "bold" : "normal",
                                            cursor: "pointer",
                                            textDecoration: selectedCategory?.name === category.name ? "underline" : "none",
                                        }}
                                    >
                                        {category.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-md-10 mt-2 mb-2">
                        <h4 style={{ marginBottom: "15px", fontWeight: "bold", color: "#333" }}>
                            {selectedCategory?.name}
                        </h4>
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "10px",
                                alignItems: "stretch", // Ensures all images in a row have the same height
                            }}
                        >
                            
                            {selectedCategory && selectedCategory.images.map((imgObj, index) => (
                                <div key={index} style={{ flex: "1 1 auto", minWidth: "150px" }}>
                                    <img
                                        src={IMG_URL + imgObj.url}
                                        alt={`Image ${index}`}
                                        onClick={() => openLightbox(imgObj.url, imgObj.location, imgObj.date, index)}
                                        style={{
                                            width: "100%",
                                            height: "200px", // Fixed row height
                                            objectFit: "cover", // Ensures the image covers the container while maintaining aspect ratio
                                            borderRadius: "5px",
                                            transition: "transform 0.3s ease-in-out",
                                            cursor: "pointer",
                                        }}
                                        onMouseOver={(e) => (e.target.style.transform = "scale(1.02)")}
                                        onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                                    />
                                </div>
                            ))}
                        </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
            {lightbox.open && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                    style={{ background: "rgba(0, 0, 0, 0.9)", zIndex: 1050 }}
                >
                    {/* Close Button */}
                    <button
                        className="position-absolute top-0 end-0 btn btn-danger"
                        onClick={closeLightbox}
                    >
                        ✖
                    </button>

                    {/* Left Navigation Arrow */}
                    <button
                        className="position-absolute start-0 top-50 translate-middle-y btn"
                        onClick={() => changeImage(-1)}
                        style={{ fontSize: "24px", padding: "10px 15px" }}
                    >
                        <span
                            style={{
                                color: "gray",
                                transition: "color 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.target.style.color = "white")} // White on hover
                            onMouseLeave={(e) => (e.target.style.color = "gray")} // Gray when mouse leaves
                        >←</span>
                    </button>

                    {/* Main Selected Image */}
                    <img
                        src={IMG_URL + lightbox.image}
                        alt="Selected"
                        className="border border-light"
                        style={{
                            height: "calc(100vh - 250px)", // Adjusted height
                            width: "auto",
                            maxWidth: "90%",
                            objectFit: "contain",
                            transition: "transform 0.3s ease-in-out",
                        }}
                    />
                    <div className="text-center text-white fw-bold mt-2">
                        Image {lightbox.index + 1} of {selectedCategory.images.length}
                        <p className='mb-0'>Location : {lightbox.location} </p>
                        <p>Date : {lightbox.date ? format(parseISO(lightbox.date), "dd-MM-yyyy") : "N/A"} </p>
                    </div>



                    {/* Right Navigation Arrow */}
                    <button
                        className="position-absolute end-0 top-50 translate-middle-y btn"
                        onClick={() => changeImage(1)}
                        style={{ fontSize: "24px", padding: "10px 15px" }}
                    >
                        <span
                            style={{
                                color: "gray",
                                transition: "color 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.target.style.color = "white")} // White on hover
                            onMouseLeave={(e) => (e.target.style.color = "gray")} // Gray when mouse leaves
                        >→</span>
                    </button>

                    {/* Thumbnails - Centered at Bottom */}
                    <div
                        className="position-absolute bottom-0 w-100 d-flex justify-content-center py-3"
                        style={{ background: "rgba(0, 0, 0, 0.6)" }}
                    >
                        {selectedCategory.images.map((thumb, index) => (
                            <img
                                key={index}
                                src={IMG_URL + thumb.url}
                                alt={`Thumbnail ${index}`}
                                onClick={() => setLightbox({ ...lightbox, image: thumb.url, location: thumb.location, date: thumb.date , index })}
                                style={{
                                    width: "80px",
                                    height: "60px",
                                    margin: "5px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    border: lightbox.index === index ? "3px solid green" : "2px solid white",
                                    objectFit: "cover",
                                }}
                            />
                        ))}
                    </div>
                </div>
            )}
      </div>
    )
  }

export default GovtDashboard